import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-reserve',
  templateUrl: './reserve.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ReserveComponent implements OnInit {
  /** Each label is the page heading for that step, so it is never also repeated below. */
  protected readonly steps = [
    { value: 1, label: 'Kies een datum' },
    { value: 2, label: 'Kies een les' },
  ];

  activeStep = 1;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.updateStep(this.router.url);
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe((event) => this.updateStep(event.urlAfterRedirects));
  }

  private updateStep(url: string): void {
    this.activeStep = url.includes('/reserveer/class') ? 2 : 1;
  }
}
